import ConfirmationModal from "@/components/display/ConfirmationModal";
import i18n from "@/i18n";
import store from "@/store";

const priorityMap = {
  Low: "info",
  Normal: "info",
  Urgent: "danger",
};

const statusMap = {
  Open: "success",
  Closed: "danger",
  "Pending Welcome Email": "warning",
};

const confirmCloseTicket = (ticket) =>
  store.dispatch("tickets/closeTicket", { id: ticket.id }).then(() => {
    store.dispatch("toasts/addToast", {
      variant: "success",
      message: i18n.t("tickets.ticket-closed", {
        ticket: ticket.mask,
      }),
    });
  });

const closeTicket = (ticket) => {
  store.dispatch("modals/open", {
    template: ConfirmationModal,
    data: {
      confirm: confirmCloseTicket.bind(null, ticket),
      errorMessage: i18n.t("tickets.error-closing-ticket"),
      message: i18n.t("tickets.confirm-ticket-close"),
      title: i18n.t("tickets.close-ticket"),
    },
  });
};

const getTicketPriorityColor = (ticket) => priorityMap[ticket?.priority?.name] ?? "info";

const getTicketStatusColor = (ticket) => statusMap[ticket?.status?.name] ?? "dark";

export { closeTicket, getTicketPriorityColor, getTicketStatusColor };
